import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, IconButton, CircularProgress } from '@mui/material';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import DownloadIcon from '@mui/icons-material/Download';
import TeleConsultationStore from '../DataRepo/TeleConsultationStore';
import loadingimg from '../Assets/images/loading image 1.png';

function Prescription() {
  
  const { id } = useParams();
  const { PrescriptionData, getPrescription, isPrescriptionLoading } = TeleConsultationStore();
  const navigate = useNavigate();

  useEffect(() => {
    getPrescription();
  }, []);

  const handlePrescription = (data) => {
    navigate(`/ViewPrescription/${data.id}`);
  };

  const handleDownload = (s3Link) => {
    const link = document.createElement('a');
    link.href = s3Link;
    link.download = true;
    link.click();
  };

  return (
    <div className='All-products-section-main'>
      <nav className='flex flex-row p-2 items-center justify-between'>
        <div className='flex flex-row items-center'>
          <IconButton onClick={() => navigate(-1)}>
            <ChevronLeft />
          </IconButton>
          <p className='mb-0'>Prescription</p>
        </div>
      </nav>

      <div className='Reports-main-page'>
        {isPrescriptionLoading ? (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
            <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
              <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
              </div>
            </div>
          </div>
        ) : PrescriptionData?.length > 0 ? (
          <div className='ListReports'>
            {PrescriptionData.sort((a, b) => new Date(b.Date) - new Date(a.Date)).map((e, i) => (
              <div key={i} className='Prescription-card' style={{ width: "100%" }}>
                <div className='flex flex-row items-center gap-14'>
                  <div>
                    <img src='/icons/Rx.png' alt='PDF icon' />
                  </div>
                  <div>
                    <p>{e?.Appointment_details?.patient_name}</p>
                    <p>{e.Date}</p>
                    <p>Prescribed by {e?.Appointment_details?.doctor_name}</p>
                  </div>
                </div>

                <div className='flex flex-row justify-between gap-5 mt-5' style={{ width: "100%" }}>
                  <div style={{ width: "30%" }}>
                    <Button
                      style={{
                        width: '100%',
                        textTransform: 'none',
                        backgroundColor: '#FDFDFD',
                        color: '#DA6E0B',
                        border: '1px solid #DA6E0B',
                        borderRadius: "5px",
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: "10px"
                      }}
                      onClick={(event) => {
                        event.stopPropagation();
                        handleDownload(e?.Prescription);
                      }}
                    >
                      <DownloadIcon />
                    </Button>
                  </div>

                  <div style={{ width: "100%" }}>
                    <Button
                      style={{
                        width: '100%',
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: 'white',
                        borderRadius: '5px',
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: '10px'
                      }}
                      onClick={() => handlePrescription(e)}
                    >
                      View
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className='No-reports'>
            <img src='https://aiwellassets.s3.ap-south-1.amazonaws.com/no+prescription.png' alt="No Prescription" />
            <p>No Prescription found</p>
            <div>
              <Button
                style={{
                  width: '100%',
                  textTransform: 'none',
                  backgroundColor: '#FDFDFD',
                  color: '#DA6E0B',
                  border: '1px solid #DA6E0B',
                  borderRadius: "5px",
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  padding: "10px"
                }}
                onClick={() => navigate('/TeleConsultation')}
              >
                Consult Doctor
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Prescription;
